import { useQueryData } from "@src/hooks/useQueryData";
import { wsInplantsServices, type WsInplant, type WsInplantExtends } from "../../../../../api/wsInplants";

/** Связи заголовка ВЗН, нужные UI карточки. */
export const WS_INPLANT_CARD_INCLUDES = {
    include: ["Sender", "SenderSection", "Receiver", "ReceiverSection", "Bo"] satisfies Array<keyof WsInplantExtends>,
    includeBo: ["State"] satisfies Array<"State">,
} as const;

/**
 * Загрузка карточки ВЗН (только данные; права — через {@link useBoRights}).
 */
export function useWsInplantCardQuery(inplantCode: number) {
    return useQueryData<WsInplant>({
        queryKey: ["workshop", "wsInplant", inplantCode, "card"],
        queryFn: async ({ signal }) => {
            const card = await wsInplantsServices.loadOne(
                {
                    flt: { Codes: [inplantCode] },
                    ...WS_INPLANT_CARD_INCLUDES,
                },
                { signal },
            );

            if (card == null) {
                throw new Error("Нет данных о текущей ВЗН");
            }

            return card;
        },
        enabled: inplantCode > 0,
        meta: { errorSource: "workshop.wsInplant.card" },
    });
}
